module.exports = __webpack_public_path__ + "static/image009-ffbfee40c0b0e863374d39c41342be9b.jpg";